import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth, resolveOnboardingPath } from "../../../contexts/AuthContext";
import { useSignup } from "../../../contexts/SignupContext";
import { accountsService } from "../../../services/accounts.service";
import OnboardingLogout from "../../../components/auth/OnboardingLogout";
import Button from "../../../ui/buttons/Button";
import BaseInput from "../../../ui/inputs/BaseInput/BaseInput";
import alertSVG from "../../../assets/icons/alert.svg";
import styles from "../../../styles/pages/auth/LoginScreen.module.css";

const CURRENT_PATH = "/signup/create-account";

export default function CreateAccountPage() {
  const navigate = useNavigate();
  const { auth, refreshMe, refreshAccounts } = useAuth();
  const { accountName, setAccountName, setAccountId } = useSignup();

  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Si el paso correcto según /me es otro (ya creó la cuenta, o el onboarding
  // está completo → null), redirigir fuera de esta pantalla.
  useEffect(() => {
    const target = resolveOnboardingPath(auth);
    if (target !== CURRENT_PATH) {
      navigate(target || "/dashboard", { replace: true });
    }
  }, [auth, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!accountName.trim()) {
      setError("Por favor, ingresá el nombre de la cuenta.");
      return;
    }

    setError("");
    setSubmitting(true);
    try {
      const account = await accountsService.create({ name: accountName.trim() });
      if (account?.id != null) setAccountId(account.id);

      await refreshMe();
      await refreshAccounts();

      navigate("/signup/plan");
    } catch (submitError) {
      setError(
        submitError?.response?.data?.detail ||
          submitError?.response?.data?.error ||
          "No se pudo crear la cuenta. Intentá nuevamente.",
      );
      console.error(submitError?.response?.data || submitError);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.login}>
      <OnboardingLogout className={styles.onboardingLogout} />

      <div className={styles.leftLogin} />

      <form onSubmit={handleSubmit} className={styles.rightLogin}>
        <h1 className={styles.loginTitle}>Creá tu cuenta</h1>

        <div className={styles.formContent}>
          <BaseInput
            label="Nombre de Cuenta"
            placeholder="Nombre de tu empresa o equipo"
            value={accountName}
            onChange={(value) => {
              setAccountName(value);
              if (error) setError("");
            }}
            validateOnChange={false}
          />

          {error && (
            <div className={styles.loginError}>
              <img src={alertSVG} alt="" aria-hidden="true" />
              {error}
            </div>
          )}

          <Button
            type="submit"
            style={{ backgroundColor: "var(--color-brand-500)", minHeight: 45 }}
            loading={submitting}
          >
            {submitting ? "Creando cuenta..." : "Continuar a elegir tu plan"}
          </Button>
        </div>
      </form>
    </div>
  );
}
